import { createTheme } from '@mui/material/styles';
import components from './components/components';

const theme = createTheme({
  direction: 'ltr',
  components: {
    ...components,
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
  },
});

export { theme };
